var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "c-box c-box--alpha" },
      [
        _vm._m(0),
        _vm._v(" "),
        _vm.is_loading
          ? [_c("loader")]
          : [
              _c(
                "div",
                { staticClass: "c-box__content" },
                [
                  _c("b-table", {
                    attrs: {
                      stacked: "lg",
                      items: _vm.entity_events,
                      fields: _vm.table_fields,
                      "show-empty": true,
                      "empty-text": "There are events available.",
                      busy: _vm.is_loading
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "table-busy",
                        fn: function() {
                          return [_c("loader", [_vm._v("loading events...")])]
                        },
                        proxy: true
                      },
                      {
                        key: "cell(entity)",
                        fn: function(data) {
                          return [
                            _vm._v(
                              "\n                        " +
                                _vm._s(data.item.entity_id) +
                                " / " +
                                _vm._s(data.item.entity_name) +
                                "\n                    "
                            )
                          ]
                        }
                      },
                      {
                        key: "cell(server_id)",
                        fn: function(data) {
                          return [
                            _vm._v(
                              "\n                        " +
                                _vm._s(data.item.event_data.server_id) +
                                "\n                    "
                            )
                          ]
                        }
                      },
                      {
                        key: "cell(event_time)",
                        fn: function(data) {
                          return [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$moment
                                    .unix(data.item.event_time)
                                    .format("YYYY-MM-DD HH:mm:ss")
                                ) +
                                "\n                    "
                            )
                          ]
                        }
                      },
                      {
                        key: "cell(event_type)",
                        fn: function(data) {
                          return [
                            _vm._v(
                              "\n                        " +
                                _vm._s(data.item.event_data.event_type) +
                                "\n                    "
                            )
                          ]
                        }
                      },
                      {
                        key: "cell(emitter)",
                        fn: function(data) {
                          return [
                            _vm._v(
                              "\n                        " +
                                _vm._s(data.item.event_data.emitter) +
                                "\n                    "
                            )
                          ]
                        }
                      },
                      {
                        key: "cell(event_message)",
                        fn: function(data) {
                          return [
                            _vm._v(
                              "\n                        " +
                                _vm._s(data.item.event_data.event_message) +
                                "\n                    "
                            )
                          ]
                        }
                      },
                      {
                        key: "cell(extra_data)",
                        fn: function(data) {
                          return [
                            _vm._v(
                              "\n                        " +
                                _vm._s(data.item.event_data.extra_data) +
                                "\n                    "
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ]
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "c-box__header" }, [
      _c("div", { staticClass: "c-box__title" }, [
        _vm._v("\n                Entity Events (last 100)\n            ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }